import { Component } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale, kaLocale } from 'ngx-bootstrap/chronos';
import { Calculate, Insurance } from './shared/insurance.model';
import { getFromLocalStorage } from './shared/helpers';
import { TravelService } from './service/travel.service';
import { Router, NavigationEnd, NavigationStart, Event as NavigationEvent   } from '@angular/router';
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  name = 'Get Current Url Route Demo';
  currentRoute: string;

  event$ 

  constructor(
    public localeService: BsLocaleService,
    public aldagi: TravelService,
    public router: Router
  ) {
    defineLocale('ka', kaLocale);
    this.localeService.use('ka');
    
    console.log(router.url);
    
    this.event$ =this.router.events.subscribe(
                (event: NavigationEvent) => {
                  if(event instanceof NavigationStart) {
                       console.log('Start:' + event.url);
                  }
    if(event instanceof NavigationEnd) {
                      console.log('End:' + event.url);
                    }
                });




  }

  calculate: Calculate;
  currency: any;

  ngOnInit() {
    this.aldagi.getAuthToken().subscribe(data => {
      localStorage.setItem('token', JSON.stringify(data.access_token));
    });

    this.calculate = JSON.parse(JSON.stringify(getFromLocalStorage('insurance')));
    if (!this.calculate) {
      this.calculate = {
          travelTypeId: 0,
          withCovid: false,
          travelPeriodInDays: 0,
          travelFranchiseTypeId: 0,
          listOfTravellerCountPerAgeRange: [
            {
              travellerAgeRangeId: 0,
              travellerCount: 0
            }
          ]
      };
    }
    this.currency = JSON.parse(localStorage.getItem('insurance'));
    if (!this.currency) {
      this.currency = {
        contactFirstName: '',
        currency: '€',
        promoCode: ''

      };
  
    localStorage.setItem('insurance', JSON.stringify(this.currency));
    localStorage.setItem('calculate', JSON.stringify(this.calculate));
  }
}
}
